// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 935 ? "doc" : chunkId) + "." + {"326":"95764dff","935":"8d5c0481"}[chunkId] + ".js";
};